import Hidden from './hidden'

export default Hidden



// WEBPACK FOOTER //
// ./src/components/fields/hidden/index.js